import { useMutation } from 'react-query';
import { createAccountRegistration } from '../api/createAccountRegistration';
import { CreateAccountRegistrationRequest } from '../models/create-account-registration-request';
import { ErrorResponse } from '../models/error-response';

export const useCreateAccountRegistration = () =>
  useMutation<unknown, ErrorResponse, CreateAccountRegistrationRequest>(
    createAccountRegistration(),
    {},
  );
